module.exports = __webpack_public_path__ + "static/media/comment4_1.79c5938e.png";